import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
    name: "navbar",
})

export default class NavBar extends Vue {
    @Prop({ required: true, type: String })
    public title: string;

    @Prop({ required: false, type: String })
    public iconRoutePath: string;

    @Prop({ required: false, type: Boolean })
    public showCleaningIcon: boolean;

    @Prop({ required: false, type: Boolean })
    public showCountPalletsIcon: boolean;

    @Prop({ required: false, type: Boolean })
    public showCountConsumablesIcon: boolean;

    public constructor() {
        super();

        this.showCleaningIcon = this.showCleaningIcon || false;
        this.showCountPalletsIcon = this.showCountPalletsIcon || false;
        this.showCountConsumablesIcon = this.showCountConsumablesIcon || false;
    }

    public toggleFullScreen(): void {
        this.$store.dispatch("app/toggleFullScreen");
    }
}
